import { Container, Row, Col } from "react-bootstrap";
import {useState,useEffect} from 'react'
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import { FaAngleDoubleUp } from "react-icons/fa";

export const Footer = () => {

  const [isVisible, setIsVisible] = useState(false);

  const goToBtn = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const listenToScroll = () => {
    let heightToHidden = 20;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    if (winScroll > heightToHidden) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
    return () => window.removeEventListener("scroll", listenToScroll);
  }, []);





  return (
    <footer className="footer" id="contacts">
      <Container>
        <Row className="align-items-center">
          
          <Col size={5} sm={6}>
            <h1>Contact</h1>
           
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a  href="https://www.linkedin.com/in/abhishek579/"><img src={navIcon1} alt="Icon" /></a>
              <a href="https://github.com/Abhishek8K"><img src={navIcon2} alt="Icon" /></a>
             
            </div>
            <p>@CopyRight 2023. All Rights Reserved</p>
            {isVisible && (
        <FaAngleDoubleUp
          className="top-btn-position top-btn-style"
          onClick={goToBtn}
        />
      )} 



            
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
